import React from 'react';

// Context that can wrap elements in order to supply
// logged in user information
const AuthUserContext = React.createContext(null);

export default AuthUserContext;
